import { PreOnboardingAlerts } from '@/components/escript/landing/PreOnboardingAlerts';
import { ChatbotWidget } from '@/components/helpdesk/ChatbotWidget';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useScrollPercentage } from '@/hooks/useScrollPercentage';
import { emitUIEvent } from '@montugroup/data-collection';
import { Box } from '@montugroup/design-system';
import { DisclaimerSection } from './DisclaimerSection';
import { PaymentSection } from './PaymentSection';
import { StepsSection } from './StepsSection';
import { SubmitSection } from './SubmitSection';

export function Landing() {
  const enableUmedsChatbot = useFeatureFlag('enable_umeds_chatbot');

  useScrollPercentage({
    onProgress: (percent) => {
      emitUIEvent(
        {
          component_name: 'landing',
          event_name: 'scroll',
          id: 'escript_onboarding',
          value: `${percent}%`,
        },
        [],
      );
    },
  });

  return (
    <Box data-testid="escriptOnboardingPage">
      <PreOnboardingAlerts />
      <SubmitSection />
      <PaymentSection />
      <StepsSection />
      <DisclaimerSection />
      {enableUmedsChatbot && <ChatbotWidget anonymous={true} />}
    </Box>
  );
}
